import React from "react";
import { Users, TrendingUp, GraduationCap, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const featuresData = [{
  title: "Patient Advocacy",
  description: "I ensure your medical needs are prioritized through detailed reviews of medical records, PSA trends, and pathology reports, translating complex clinical information into clear, understandable language for you and your family.",
  icon: Users,
  link: "/NavigationServicesPage"
}, {
  title: "Care Coordination",
  description: "I organize your journey by preparing you for visits with urologists and oncologists. I help patients organize their medical history and develop meaningful questions to ensure productive discussions with their care team.",
  icon: TrendingUp,
  link: "/NavigationServicesPage"
}, {
  title: "Family Guidance",
  description: "Empowering families with the resources needed to navigate care. I offer dedicated support for spouses and caregivers, helping them understand the diagnosis and how to best support their loved one through decision making.",
  icon: GraduationCap,
  link: "/FamilySupportPage"
}];
export default function Features() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="4038" id="core-services" ref={ref} className={`w-full bg-muted text-foreground py-[120px] transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="mb-16 text-center">
          <h2 className="text-[32px] md:text-4xl font-serif font-bold text-foreground mb-4">My Core Services</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg tracking-normal font-sans">I provide professional guidance to navigate complex healthcare systems, ensuring families receive the support and clarity they deserve.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featuresData.map((feature, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full border border-border bg-card text-card-foreground rounded-[24px] shadow-sm hover:shadow-lg hover:border-ring transition-all duration-300 ease-out flex flex-col">
                <CardHeader className="pb-4 pt-8 px-8">
                  <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-full bg-secondary/10 text-secondary">
                    <feature.icon className="w-7 h-7 stroke-2" />
                  </div>
                  <CardTitle className="text-[32px] font-serif font-semibold leading-tight text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-8 pb-8 flex-grow flex flex-col justify-between">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed tracking-normal font-sans mb-6">
                    {feature.description}
                  </CardDescription>
                  
                  <div className="mt-auto pt-4">
                    <Button variant="link" className="p-0 h-auto text-secondary font-medium group" asChild>
                      
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}